import * as seedrandom from 'seedrandom';

export const pseudoRandom = (
  seed: string,
  min: number,
  max: number
): number => {
  // min and max included
  const random = new seedrandom(seed);
  return Math.floor(random() * (max - min + 1) + min);
};
